import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { IASCategoriesFetchFailed } from "./errors";
import { toQueryParams } from "./filters";
export default class IASCategories extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "ias-categories", { atomize: true });
        this.url = `${this.sdk.urls.baseAPIUrl}/ext-segments/contextual`;
    }
    /**
     * Returns IAS categories with optional server-side filtering and pagination.
     *
     * @param filters - Optional filters including search and pagination
     * @param sort - Optional sort configuration
     * @returns A promise that resolves to an array of IAS category names
     * @throws {IASCategoriesFetchFailed} If the fetch operation fails
     */
    async findItems(filters, sort) {
        const params = toQueryParams(filters, sort);
        const url = `${this.url}${params}`;
        return this.cache.promise(url, () => axios
            .get(url)
            .then(({ data }) => {
            const segments = Array.isArray(data) ? data : [data];
            return segments.flatMap((segment) => segment?.data ?? []);
        })
            .catch(() => {
            throw new IASCategoriesFetchFailed();
        }));
    }
    async saveItem() {
        throw new NotImplementedError("save");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export * from "./types";
//# sourceMappingURL=index.js.map